import { APP_CONFIG } from "../constants/global-variables.js";
export async function getGamesList() {
    const url = `${APP_CONFIG.URL.apiBasePath}gs/getgameslist`;
    const aa = localStorage.getItem("access_token");
    try {
        const res = await axios.get(url, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                "Content-Type": "application/json",
            },
        });
      return res.data;
    } catch (err) {
        //console.log('Error getting documents', err);
    }
}

export async function getStargames(hallid) {
    const hallId =  hallid.hall;
    const aa = localStorage.getItem("access_token");
    try {
        const res = await axios.get(`https://apiserver.solutions/remote_games_list?type=html5&hallid=${hallId}&nocache=1&format=json`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                "Content-Type": "application/json",
            },
        });
        return res.data;
    } catch (err) {
        //console.log('Error getting documents', err);
    }
}

export async function getJackpotsStarGame(sessionid,key1,key2) {
    const aa = localStorage.getItem("access_token");
    try {
        const res = await axios.get(`https://ac.umbrella-corp.company/jackpot/current?sid=${sessionid}&key1=${key1}&key2=${key2}`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                "Content-Type": "application/json",
            },
        });
        return res.data;
    } catch (err) {
        //console.log('Error getting documents', err);
    }
}


export async function registerDeluxeCasino() {
    const url = `${APP_CONFIG.URL.apiBasePath}gs/register`;
    const aa = localStorage.getItem("access_token");
    try {
        const res = await axios.get(url, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                "Content-Type": "application/json",
            },
        });
      return res.data;
    } catch (err) {
        //console.log('Error getting documents', err);
    }
}


export async function loginDeluxeCasino() {
    const url = `${APP_CONFIG.URL.apiBasePath}gs/login`;
    try {
        const res = await axios.get(url, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                "Content-Type": "application/json",
            },
        });
      return res.data;
    } catch (err) {
        //console.log('Error getting documents', err);
    }
}